import { AnimatePresence, motion } from 'motion/react'
import { ReactElement } from 'react'

import { TSvgIcon } from '@/types'

export const SocialItem = ({
	content,
}: {
	Icon: TSvgIcon
	content: ReactElement
}) => (
	<AnimatePresence initial={false}>
		<motion.div
			initial={{ height: 0 }}
			animate={{ height: 'auto' }}
			exit={{ height: 0 }}
			className="overflow-hidden"
		>
			<div className="px-5 py-4">{content}</div>
		</motion.div>
	</AnimatePresence>
)
